export default ({ data }) => {
  return {
    text: data.text,
    subtext: data.subtext,
    icon: data.icon,
  };
};
